import TimeAgo from 'javascript-time-ago'
import vi from 'javascript-time-ago/locale/vi'

TimeAgo.addLocale(vi)
const timeAgo = new TimeAgo('vi')

/**
 * Returns a formatted string representing how much time has passed since the given date.
 *
 * @param {Date|string|number} date - The date to calculate the time ago from. Can be a Date object or a date string.
 * @returns {string} - A human-readable string indicating the time elapsed since the given date, with 'bây giờ' replaced by 'vừa xong'.
 */

export const getDateAgo = date => {
  if (!date) return ''
  return timeAgo.format(new Date(date)).replace('bây giờ', 'vừa xong')
}

/**
 * So sánh hai đối tượng xem chúng có bằng nhau không.
 *
 * @param {any} x - Đối tượng đầu tiên để so sánh.
 * @param {any} y - Đối tượng thứ hai để so sánh.
 * @returns {boolean} - Trả về true nếu hai đối tượng bằng nhau, ngược lại trả về false.
 */
export const compareObject = (x, y) => {
  if (x === y) return true
  // nếu cả x và y đều null hoặc undefined và giống nhau chính xác

  if (!(x instanceof Object) || !(y instanceof Object)) return false
  // nếu chúng không hoàn toàn bằng nhau, cả hai đều cần phải là đối tượng

  if (x.constructor !== y.constructor) return false
  // chúng phải có cùng một chuỗi nguyên mẫu, gần nhất chúng ta có thể kiểm tra
  // là kiểm tra constructor của chúng.

  for (const p in x) {
    if (!x[p]) continue
    // các thuộc tính khác đã được kiểm tra bằng x.constructor === y.constructor

    if (!y[p]) return false
    // cho phép so sánh x[p] và y[p] khi đặt thành undefined

    if (x[p] === y[p]) continue
    // nếu chúng có cùng giá trị hoặc danh tính nghiêm ngặt thì chúng bằng nhau

    if (typeof x[p] !== 'object') return false
    // Các số, chuỗi, hàm, boolean phải hoàn toàn bằng nhau

    if (!compareObject(x[p], y[p])) return false
    // Các đối tượng và mảng phải được kiểm tra đệ quy
  }

  for (const p in y) if (y[p] && !x[p]) return false
  // cho phép x[p] được đặt thành undefined

  return true
}

export const getBrowserName = () => {
  const userAgent = navigator.userAgent.toLowerCase()

  if (
    userAgent.indexOf('chrome') > -1 &&
    userAgent.indexOf('edg') === -1 &&
    userAgent.indexOf('opr') === -1
  ) {
    return 'Chrome'
  } else if (userAgent.indexOf('firefox') > -1) {
    return 'Firefox'
  } else if (userAgent.indexOf('safari') > -1 && userAgent.indexOf('chrome') === -1) {
    return 'Safari'
  } else if (userAgent.indexOf('edg') > -1) {
    return 'Edge'
  } else if (userAgent.indexOf('opr') > -1 || userAgent.indexOf('opera') > -1) {
    return 'Opera'
  } else {
    return 'Unknown'
  }
}

/**
 * Trả về một đối tượng phẳng (flat) được tạo ra từ đối tượng obj.
 * Các key của đối tượng phẳng được tạo ra bằng cách nối các key của đối tượng gốc bằng dấu chấm (.) và
 * các key của các phần tử trong mảng được đánh số thứ tự (vì các key của mảng không được phép lặp lại).
 *
 * Ví dụ:
 * Input: { a: { b: 1, c: [2, 3] }, d: 4 }
 * Output: { 'a.b': 1, 'a.c[0]': 2, 'a.c[1]': 3, d: 4 }
 *
 * @param {Object} obj - Đối tượng cần được flatten.
 * @returns {Object} - Đối tượng phẳng được tạo ra.
 */

export const flatObject = obj => {
  const result = {}

  function flatten(currentObj, prefix = '') {
    // Nếu là null hoặc undefined thì return luôn
    if (currentObj === null || currentObj === undefined) {
      result[prefix] = currentObj
      return
    }

    // Nếu là primitive value thì set vào result và return
    if (typeof currentObj !== 'object') {
      result[prefix] = currentObj
      return
    }

    // Nếu là array
    if (Array.isArray(currentObj)) {
      // Lưu lại array gốc
      result[prefix] = currentObj

      // Flatten từng phần tử của array với key dạng prefix[index]
      currentObj.forEach((item, index) => {
        const newPrefix = prefix ? `${prefix}[${index}]` : `[${index}]`
        flatten(item, newPrefix)
      })
      return
    }

    // Kiểm tra nếu object có cấu trúc giống sender
    if (currentObj.type && currentObj.email && currentObj.name) {
      result[prefix] = currentObj
      return
    }

    // Nếu là object thông thường
    const keys = Object.keys(currentObj)
    keys.forEach(key => {
      const newPrefix = prefix ? `${prefix}.${key}` : key
      flatten(currentObj[key], newPrefix)
    })
  }

  flatten(obj)
  return result
}

export const getFileExtension = url => {
  const match = url.match(/\.[0-9a-z]+$/i)
  return match ? match[0] : ''
}

// timestamp | date | string

export function getLastNDays(days = 7, type = 'timestamp') {
  const today = new Date()
  const to = new Date(today)
  const from = new Date(today)
  from.setDate(from.getDate() - (days - 1)) // days ngày gồm cả hôm nay

  const formatDate = date => {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  const transform = date => {
    switch (type) {
      case 'timestamp':
        return date.getTime()
      case 'date':
        return date
      case 'string':
      default:
        return formatDate(date)
    }
  }

  return {
    from: transform(from),
    to: transform(to),
  }
}
